export default __webpack_public_path__ + "static/media/rejection-icon.b145c49c.svg";